export default __webpack_public_path__ + "static/media/Book-5.8890fe78.jpg";